<template>
  <div class="page">
    <div class="bar">
      <RangeSelector :submit-method="submitincoming"/>
      <nav class="m-2">
        <div class="d-flex">
          <div class="nav nav-tabs" id="nav-tab" role="tablist">
            <button class="nav-link active" id="nav-home-tab" data-bs-toggle="tab" data-bs-target="#nav-home" type="button"
                    role="tab" aria-controls="nav-home" @click="changeActiveTab('PENDING')" aria-selected="true">PENDING
            </button>
            <button class="nav-link" id="nav-manager-tab" data-bs-toggle="tab" data-bs-target="#nav-manager" type="button"
                    role="tab" aria-controls="nav-manager" @click="changeActiveTab('AWAITING MANAGER APPROVAL')" aria-selected="false">
              MANAGER
            </button>
            <button class="nav-link" id="nav-profile-tab" data-bs-toggle="tab" data-bs-target="#nav-profile" type="button"
                    role="tab" aria-controls="nav-profile" @click="changeActiveTab('APPROVED')" aria-selected="false">
              APPROVED
            </button>
            <button class="nav-link" id="nav-contact-tab" data-bs-toggle="tab" data-bs-target="#nav-contact" type="button"
                    role="tab" aria-controls="nav-contact" @click="changeActiveTab('DECLINED')" aria-selected="false">
              DECLINED
            </button>
          </div>
<!--          <ApproveButton-->
<!--              style="margin-right: 5px"-->
<!--              buttonText="Filter Results"-->
<!--              @click="showFilterModal"-->
<!--          />-->
        </div>
      </nav>
    </div>

    <div class="m-2 request-container" style="height: 100%">
      <div class="card mb-2 p-2" v-for="request in filteredRequests">
<!--        <button @click="checker(request)">CHECK</button>-->
        <b class="fw-500 mx-2 mb-1"><span
            :class="`badge h-auto`+badgeStatus(request.status)">{{ request.status }}</span></b>
        <div class="row mb-1">
          <div class="col-4">
            <div class="d-flex flex-column">
              <b class="fw-500 mx-2 mb-1">{{ $utils.formatMoney(request.amount) }}</b>
              <span class="text-sm">({{ request.reference }})</span>
            </div>
          </div>
          <div class="col-4 d-flex flex-column">
            <b class="text-center fw-500 mb-1">{{ request.requestUser }}</b>
            <span class="text-center text-sm">({{ request.subType }})</span>
          </div>
          <div class="col-4">
            <div class="d-flex flex-row">
              <div class="d-flex flex-column mx-1 border" v-if="checkForPhoto(request)">
                <img
                    src="../assets/img/camera.webp"
                    v-gallery
                    :data-large="pettyCashApi+`getImageByRequestID/${request.id}`"
                    alt="Product Image" width="25"
                    height="25"
                />
              </div>

              <a class="btn btn-danger border" v-if="status === 'PENDING' && compare.username === request.requestUser" @click="denyRequest(request)">
                <font-awesome-icon icon="trash"/>
              </a>
            </div>
            <b>{{ request.department }}</b>
          </div>
        </div>
        <div class="row mb-1">
          <div class="col-6 d-flex flex-column">
            <div class="text-sm fw-bolder">Date : {{ $utils.displayDate(request.requestDate) }}</div>
            <div class="text-sm">{{ request.provider }}</div>
          </div>
          <div class="col-6 d-flex flex-column">
            <a class="text-dark btn fw-bolder" v-if="request.ticketNumber && request.ticketNumber !== 0" @click="viewTicket(request)">
              Ticket #{{ request.ticketNumber }}
              <font-awesome-icon icon="external-link" />
            </a>
            <a class="text-dark btn fw-bolder" v-if="request.purchaseOrder && request.purchaseOrder !== `0`" @click="viewPurchaseOrder(request)">
              PO. {{ request.purchaseOrder }}
              <font-awesome-icon icon="external-link" />
            </a>
            <span class="fw-bold" v-if="request.declineReason">Declined For : {{ request.declineReason }}</span>
          </div>
        </div>
        <div class="row d-flex justify-content-center">
          <hr style="width: 90%" />
          <div class="col-12 fw-bolder text-center">{{ request.reason }}</div>
          <div class="col-12 text-center mt-2" v-if="request.type === 'SHIPPING'">
            <div><strong>Supplier:</strong> {{ request.supplier || 'N/A' }}</div>
            <div><strong>Store:</strong> {{ request.storeId || 'N/A' }}</div>
            <div><strong>Invoice:</strong> {{ request.invoiceId || 'N/A' }}</div>
          </div>
        </div>
      </div>
    </div>

    <div style="height: 1px"></div>

    <div v-if="filterModal" class="modal-overlay">
      <div class="modal-content form-container">
        <div class="modal-header" >
          <h3>Select Your Search Parameters</h3>
        </div>
        <div class="modal-bodyy">
          <div class="filter">
            <select
                class="form-select"
                id="floatingSelect"
                aria-label="Floating label select example"
                v-model="selectedDepartment"
            >
              <option disabled value="" style="margin-top: 10px">Select Department</option>
              <option
                  v-for="role in roles"
                  :key="role.id"
                  :value="role.name"
              >
                {{ role.name }}
              </option>
            </select>
            <select
                style="margin: 5px;"
                id="department"
                class="form-control"
                v-model="selectedOffice"
            >
              <option disabled value="" style="margin-top: 10px">Select Office</option>
              <option v-for="dept in allOffices" :key="dept.id" :value="dept.name">
                {{ dept.name }}
              </option>
            </select>
            <select
                v-model="selectedStatus"
                class="form-select"
            >
              <option value="all">All</option>
              <option value="active">Active</option>
              <option value="archived">Archived</option>
            </select>
            <select
                style="margin: 5px;"
                id="department"
                class="form-control"
                v-model="selectedUsers"
            >
              <option disabled value="" style="margin-top: 10px">Select User</option>
              <option v-for="user in filteredUsers" :key="user.id" :value="user.Username">
                {{ user.Username }}
              </option>
            </select>
          </div>
          <div class="filter">
            <input
                placeholder="Search by reason"
                style="width: 100%; height: 35px; margin: 5px"
                v-model="reason"
            />
            <input
                placeholder="Search by ticket number"
                style="width: 100%; height: 35px; margin: 5px"
                v-model="ticketNumber"
            />
          </div>
        </div>
        <div class="flexy">
          <ApproveButton
              buttonText="Check Results"
              hoverTextColor="#ffffff"
              @click="closeFilterModal"
          />
        </div>
        <div v-if="isLoading" class="overlay">
          <section class="dots-container">
            <div class="dot"></div>
            <div class="dot"></div>
            <div class="dot"></div>
            <div class="dot"></div>
          </section>
        </div>
      </div>
    </div>
    <floating-add-button @click="showFilterModal"/>
  </div>
</template>
<script>
import FloatingAddButton from "@/components/layout/utils/FilterButton.vue";
import RangeSelector from "@/components/layout/RangeSelector.vue";
import axios from 'axios';
import Swal from "sweetalert2";
import {Storage} from "@/Services/Storage";
import ApproveButton from "@/components/buttons/ApproveButton.vue";

export default {
  name: "wallet",
  components: {
    ApproveButton,
    FloatingAddButton,
    RangeSelector,
  },
  data() {
    return {
      ticketNumber: '',
      isLoading: false,
      reason: '',
      selectedStatus: "active",
      selectedUsers: '',
      selectedDepartment: '',
      selectedOffice: "",
      roles: [],
      allOffices: '',
      filterModal: false,
      holder: '',
      compare: '',
      columns: [
        {label: 'Requested By', field: 'requestUser'},
        {label: 'Number Recieving', field: 'reference'},
        {label: 'Amount', field: 'amount', type: 'number'},
        {label: 'Reason', field: 'reason'},
        {label: 'Supplier', field: 'supplier'},
        {label: 'Store', field: 'storeId'},
        {label: 'Invoice', field: 'invoiceId'},
        {label: 'requestDate', field: 'requestDate'},
        {label: 'from', field: 'from'},
        {label: 'to', field: 'to'},
        {label: 'declineReason', field: 'declineReason'},
      ],
      rows: [],
      form2: {
        amount: '',
        reason: '',
        from: ''
      },
      searchQuery: {
        username: '',
        limit: 50,
        phoneNumber: '',
        reason: ''
      },
      pettyCashApi: ticketApi2,
      status: 'PENDING' // Default status value
    };
  },
  computed: {
    $utils(){
      return $utils;
    },
    filteredUsers() {
      if (!Array.isArray(this.allUsers)) return []; // Ensure it's an array before filtering

      return this.allUsers.filter((user) => {

        // Text Search Filter
        // const matchesText =
        //     user.firstName.toLowerCase().includes(this.input.toLowerCase()) ||
        //     user.lastName.toLowerCase().includes(this.input.toLowerCase()) ||
        //     user.Username.toLowerCase().includes(this.input.toLowerCase());

        // Status Filter
        const matchesStatus =
            this.selectedStatus === "all" ||
            (this.selectedStatus === "active" && !user.archived) ||
            (this.selectedStatus === "archived" && user.archived);

        // Type Filter
        const matchesType =
            !this.selectedRole || user.Type === this.selectedRole;

        const matchesOffice =
            !this.selectedOffice || user.officeID === this.selectedOffice;

        return matchesStatus && matchesType && matchesOffice;
      });
    },
    filteredRequests() {
      if (!Array.isArray(this.rows)) return []; // Ensure it's an array before filtering

      return this.rows.filter((ticket) => {
        // Convert input values to lowercase for case-insensitive comparison
        const ticketNumberInput = this.ticketNumber?.toLowerCase() || '';
        const requestUserInput = this.selectedUsers?.toLowerCase() || '';
        const reasonInput = this.reason?.toLowerCase() || '';
        const departmentInput = this.selectedDepartment?.toLowerCase() || '';
        const officeInput = this.selectedOffice?.toLowerCase() || '';

        const status = this.status?.toLowerCase() || '';
        this.holder = ticket;
        const holder = 'lusaka'

        // Check if each field matches the respective filter input (if provided)
        const matchesTicketNumber = !ticketNumberInput || ticket.ticketNumber.toLowerCase().includes(ticketNumberInput);
        const matchesRequestUser = !requestUserInput || ticket.requestUser.toLowerCase().includes(requestUserInput);
        const matchesReason = !reasonInput || ticket.reason.toLowerCase().includes(reasonInput);
        const matchesDepartment = !departmentInput || ticket.department.toLowerCase().includes(departmentInput);
        const matchesOffice = !officeInput || ticket.office.toLowerCase().includes(officeInput);


        // Return tickets that match all provided filters
        return matchesTicketNumber && matchesRequestUser && matchesReason && matchesDepartment && matchesOffice;
      });
    },

    filteredColumns() {
      if (this.status === 'APPROVED') {
        return this.columns.filter(col => ['requestUser', 'reference', 'amount', 'reason', 'supplier', 'storeId', 'invoiceId', 'requestDate'].includes(col.field));
      } else if (this.status === 'DECLINED') {
        return this.columns.filter(col => ['requestUser', 'reference', 'amount', 'reason', 'supplier', 'storeId', 'invoiceId', 'declineReason', 'requestDate'].includes(col.field));
      } else {
        return this.columns.filter(col => ['requestUser', 'reference', 'amount', 'reason', 'supplier', 'storeId', 'invoiceId', 'requestDate'].includes(col.field));
      }
    }
  },
  async created() {
    this.getRoles();
    this.getAllUsers();
    this.getOffices();
    this.compare = await Storage.getCurrentUser();
    // this.checkForPhoto();
  },
  beforeMount() {
    this.submitincoming();
    this.getwallets();
  },
  methods: {
    checker(r) {
      console.log(r);
    },
    showFilterModal() {
      this.ticketNumber = '';
      this.reason = '';
      this.selectedUsers = '';
      this.selectedDepartment = '';
      this.filterModal = true;
    },
    closeFilterModal() {
      this.filterModal = false;
    },
    getAllUsers() {
      axios.get(`${ticketApi}user/getAll`)
          .then(response => {
            this.allUsers = response.data; // Ensure this is an array
            console.log(this.allUsers);
          })
          .catch(error => {
            errorHandler.tomcatError(error);
          });
    },
    getOffices() {
      axios.get(`${synergyApi}employee/getOffices`)
          .then(response => {
            this.allOffices = response.data;
            console.log(this.allOffices);
          })
          .catch(error => {
            errorHandler.tomcatError(error);
          });
    },
    getRoles() {
      axios.get(`${synergyApi}employee/getAllDepartments`)
          .then(response => {
            this.roles = response.data; // Ensure this is an array
            console.log(this.roles);
          })
          .catch(error => {
            errorHandler.tomcatError(error);
          });
    },
    checkForPhoto(request) {
      return request.image !== '0';
    },
    async viewTicket(request) {
      const ticket = request.ticketNumber;
      return window.open(`https://hd.chrilantech.com/ticket/${ticket}`)
    },
    async viewPurchaseOrder(request) {
      const poNumber = request.purchaseOrder;
      return window.open(`https://tom9.pos.co.zm/PrintApi/creditor/burntofi_chrilan/printPurchaseOrder?id=${poNumber}&User=Auto`)
    },
    async denyRequest(request) {
      return Swal.fire({
        icon: `question`,
        title: `Deny Reason`,
        input: `textarea`,
        showCloseButton: true,
        showCancelButton: true,
        showLoaderOnConfirm: !Swal.isLoading(),
        preConfirm: async (inputValue) => {
          if (!inputValue) return Swal.showValidationMessage(`Reason is Required`);
          const id = request.id;
          const type = 'USER';
          const declinedBy = this.compare.username;
          const url = `${ticketApi2}decline`;

          const requestBody = {
            id: id,
            type: type,
            reason: inputValue,
            declinedBy: declinedBy
          };
          try {
            await axios.post(url, requestBody);
            responses.showInfo(`Request Declined Successfully`);
            return this.submitincoming(); // Refresh the card list
          } catch (error) {
            try {
              errorHandler.tomcatError(error, true, `Cannot Decline Request`);
            } catch (e) {
              // Extract the main error message and the first few lines of the stack trace
              const mainErrorMessage = e.message.split('\n')[0]; // Get the first line of the error message
              const shortStackTrace = e.stack.split('\n').slice(1, 4).join('\n'); // Get the next 3 lines of the stack trace
              const formattedError = `${mainErrorMessage}\n${shortStackTrace}`;

              // Display the formatted error message in SweetAlert
              return Swal.showValidationMessage(formattedError);
            }
          }
        }
      })
    },
    badgeStatus(status) {
      switch (status) {
        case 'DECLINED':
          return ` bg-danger`;
        case 'APPROVED':
          return ` bg-success`;
        default:
          return ` bg-warning`;
      }
    },
    async getwallets() {
      this.$utils.showLoading();
      try {
        const response = await axios.get(ticketApi2 + 'get-all-wallets');
        this.wallets = response.data; // Assign the fetched data to wallets
        console.log('Wallets:', this.wallets); // Log the wallets data to see the fetched data
      } catch (error) {
        return errorHandler.tomcatError(error)
      } finally {
        this.$utils.hideLoading();
      }
    },
    navigateToSelectUserPage() {
      this.$router.push({name: 'SelectRequest'}); // Replace 'selectUser' with the actual route name
    },
    async submitincoming() {
      this.$utils.showLoading();
      try {
        const params = new URLSearchParams();

        // Add date range params
        const globalDateRange = this.$store.getters.getGlobalDateRange;
        for (const [key, value] of Object.entries(globalDateRange)) {
          params.append(key, value);
        }

        // Add status param
        params.append('status', this.status);

        // Add type param
        params.append('type', 'user');

        this.rows = await this.$store.dispatch('getwallets', params.toString());
      } catch (error) {
        return errorHandler.tomcatError(error)
      } finally {
        this.$utils.hideLoading();
      }
    },
    updateColumns() {
      this.submitincoming();
    },
    changeActiveTab(status) {
      this.status = status;
      return this.submitincoming();
    },
  }
};
</script>

<style scoped lang="scss">
.flexy {
  display: flex;
  justify-content: center;
  align-items: center;
}
.d-flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.page {
  height: 90vh;
  overflow-y: scroll !important;
}

.bar {
  position: sticky;
  top: 10px;
  left: 0;
  right: 0;
  background-color: rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(2px);
  z-index: 1000;
}

.button-container {
  list-style: none;
  padding: 0;
  display: flex;
  justify-content: center;
}

#vgt-table td {
  text-align: center !important;
}

.accept-button,
.delete-button {
  border: none;
  padding: 8px 16px;
  margin: 5px;
  cursor: pointer;
  font-weight: bold;
  border-radius: 5px;
  transition: background-color 0.3s, color 0.3s;
}

.accept-button {
  background-color: #28a745;
  color: white;
}

.delete-button {
  background-color: #dc3545;
  color: white;
}

.accept-button:hover,
.delete-button:hover {
  background-color: transparent;
  color: #333;
  outline: 1px solid #333;
}

.form-check-inline {
  margin-right: 10px;
}

.form-check-input {
  margin-right: 5px;
}

.text-sm {
  font-size: 12px;
}
.border{
  width: 35px; /* Set to icon size */
  height: 35px; /* Set to icon size */
  border-radius: 15%; /* Make the button circular */
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 6px;
}
.request-container{
  height: 45vh;
  overflow-y: auto;
  overflow-x : hidden;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}
.modal-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: white;
  padding: 5px;
  border-radius: 8px;
  text-align: center;
  width: 95%;
  max-width: 95%;
  max-height: 99vh;
  overflow: hidden;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}
.modal-bodyy {
  flex: 1; /* Makes the body take up remaining space */
  overflow-y: auto; /* Enables vertical scrolling */
  padding: 1rem;
  width: 100%;
}
.modal-header {
  position: sticky;
  top: 10px;
  left: 0;
  right: 0;
  background-color: rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(2px);
  z-index: 1000;
}

.form-container {
  position: relative;
}
.filter {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);  /* Semi-transparent overlay */
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;  /* Ensure it covers the form */
  pointer-events: all;  /* Block interactions */
}
.dots-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
}

.dot {
  height: 20px;
  width: 20px;
  margin-right: 10px;
  border-radius: 10px;
  background-color: #b3d4fc;
  animation: pulse 1.5s infinite ease-in-out;
}

.dot:last-child {
  margin-right: 0;
}

.dot:nth-child(1) {
  animation-delay: -0.3s;
}

.dot:nth-child(2) {
  animation-delay: -0.1s;
}

.dot:nth-child(3) {
  animation-delay: 0.1s;
}

@keyframes pulse {
  0% {
    transform: scale(0.8);
    background-color: #b3d4fc;
    box-shadow: 0 0 0 0 rgba(178, 212, 252, 0.7);
  }

  50% {
    transform: scale(1.2);
    background-color: #6793fb;
    box-shadow: 0 0 0 10px rgba(178, 212, 252, 0);
  }

  100% {
    transform: scale(0.8);
    background-color: #b3d4fc;
    box-shadow: 0 0 0 0 rgba(178, 212, 252, 0.7);
  }
}
</style>
